var DESKTOP_SWATCHES = 7;
var MOBILE_SWATCHES = 3;
var BREAKPOINT = 999;

function initProductCards(parent = document) {
  var allCards = parent.querySelectorAll(".card-product");
  allCards.forEach(function (product) {
    setupSwatchRow(product);
    setupCardGallery(product);
    product.addEventListener("click", function (e) {
      var colorOption = e.target.closest(".card-product__color-option");
      if (colorOption) {
        e.preventDefault();
        handleColorSwatch(colorOption, product);
      }
    });
  });
}

function setupCardGallery(card) {
  var track = card.querySelector("[data-card-gallery]");
  if (!track) return;
  var max = parseInt(track.getAttribute("data-max") || "1", 10);
  if (max <= 1) return;
  var prevBtn = card.querySelector("[data-card-gallery-prev]");
  var nextBtn = card.querySelector("[data-card-gallery-next]");
  var index = 0;

  function applyTransform() {
    track.style.transform = "translateX(-" + 100 * index + "%)";
  }

  function goNext() {
    index = (index + 1) % max;
    applyTransform();
  }

  function goPrev() {
    index = (index - 1 + max) % max;
    applyTransform();
  }

  if (prevBtn) {
    prevBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      goPrev();
    });
  }
  if (nextBtn) {
    nextBtn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      goNext();
    });
  }

  applyTransform();
}

function setupSwatchRow(product) {
  var row = product.querySelector(".card-product__colors--row");
  if (!row) return;
  var options = row.querySelectorAll(".card-product__color-option");
  var moreEl = row.querySelector(".card-product__colors-more");
  var total = options.length;
  if (total === 0) {
    row.classList.add("is-ready");
    row.removeAttribute("aria-hidden");
    return;
  }

  function updateVisibility() {
    var isDesktop = window.innerWidth >= BREAKPOINT;
    var limit = isDesktop ? DESKTOP_SWATCHES : MOBILE_SWATCHES;
    var rest = total - limit;
    options.forEach(function (el, i) {
      if (i < limit) {
        el.classList.remove("hidden");
        el.style.display = "";
      } else {
        el.classList.add("hidden");
        el.style.display = "none";
      }
    });
    if (moreEl) {
      if (rest > 0) {
        moreEl.textContent = isDesktop
          ? "+ " + rest + " more"
          : "(+ " + rest + " more)";
        moreEl.style.display = "";
      } else {
        moreEl.textContent = "";
        moreEl.style.display = "none";
      }
    }
    row.classList.add("is-ready");
    row.removeAttribute("aria-hidden");
  }

  updateVisibility();
  var resizeTimeout;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(updateVisibility, 50);
  });
}

function handleColorSwatch(colorOption, productCard) {
  if (colorOption.getAttribute("aria-current") === "true") return;
  var featuredImage = productCard.querySelector(
    ".card-product__image-container .card-product__image"
  );
  var colors = colorOption.closest(".card-product__colors");
  if (colors) {
    colors
      .querySelectorAll(".card-product__color-option")
      .forEach(function (btn) {
        btn.setAttribute("aria-current", "false");
      });
  }
  colorOption.setAttribute("aria-current", "true");
  var newImageSrc = colorOption.dataset.imageSrc;
  var newAltText = colorOption.dataset.imageAlt;
  if (featuredImage && newImageSrc) {
    featuredImage.src = newImageSrc;
    featuredImage.alt = newAltText;
  }
}

document.addEventListener("DOMContentLoaded", function () {
  initProductCards();
  window.initProductCards = initProductCards;
});
